import * as React from 'react';

import PlayImg from '../../../assets/images/PlayButtonIcon.svg?url';

interface PlayerOverlayProps {
  playing?: boolean;
  onPlay: React.MouseEventHandler;
  previewImageUrl: string;
  previewImageAltText?: string;
}

export const PlayerOverlay: React.FC<PlayerOverlayProps> = ({
  onPlay,
  previewImageUrl,
  previewImageAltText,
}) => {
  return (
    <>
      <img
        src={previewImageUrl}
        alt={previewImageAltText || ''}
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
        }}
      />
      <div
        style={{
          width: '100%',
          height: '100%',
          position: 'absolute',
          left: 0,
          top: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.35)',
        }}
      />
      <button
        onClick={onPlay}
        style={{
          width: '71px',
          height: '71px',
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          background: 'transparent',
          border: 'none',
          borderRadius: '50%',
          padding: 0,
          margin: 0,
        }}
      >
        <img src={PlayImg} alt="" />
      </button>
    </>
  );
};
